export default "__VITE_ASSET__Cjjrzi1E__"